import React from 'react';

import { Divider, List, makeStyles, Typography } from '@material-ui/core';

import NavItem from '../NavItem';
import NavCollapse from '../NavCollapse';
import PagePath, { PageType } from '../../../../../Route/PagePath';
import { FormattedMessage } from 'react-intl';

const useStyles = makeStyles((theme) => ({
    menuCaption: {
        ...theme.typography.menuCaption
    },
    subMenuCaption: {
        ...theme.typography.subMenuCaption
    },
    menuDivider: {
        marginTop: '2px',
        marginBottom: '10px'
    }
}));
interface NavGroupProps {
    item: PagePath
}
const NavGroup = (props: NavGroupProps) => {
    const { item } = props;
    const classes = useStyles();



    if (!item.content?.length) {
        item.content = [];
    }
    //debugger

    const items = item.content.map((menu: PagePath) => {
        var itemType = menu.content?.length > 0 ? PageType.collapse : PageType.item;
        menu.type = itemType;
        switch (itemType) {
            case PageType.collapse:
                return <NavCollapse key={menu.label} menu={menu} level={1} />
            case PageType.item:
                return <NavItem key={menu.label} item={menu} level={1} />
            default:
                return (
                    <Typography key={menu.label} variant="h6" color="error" align="center">
                        Menu Items Error
                    </Typography>
                );
        }
    });

    return (
        <React.Fragment>
            <List
                subheader={
                    item.label ? (
                        <Typography variant="caption" className={classes.menuCaption} display="block" gutterBottom>
                            <FormattedMessage id={item.LocalePath} defaultMessage={item.label} />
                            {item.description && (
                                <Typography variant="caption" className={classes.subMenuCaption} display="block" gutterBottom>
                                    <FormattedMessage id={item.description} defaultMessage={item.description} />
                                </Typography>
                            )}
                        </Typography>
                    ) : <></>
                }
            >
                {items}
            </List>
            <Divider className={classes.menuDivider} />
        </React.Fragment>
    );
};

export default NavGroup;
